import { useEffect, useState } from "react";

export const useChatSectionState = <T extends string>(
  storageKey: string,
  defaultKey: T,
  allowedKeys: readonly T[],
) => {
  const [state, setState] = useState<T>(() => {
    if (typeof window === "undefined") {
      return defaultKey;
    }

    try {
      const saved = localStorage.getItem(storageKey);
      if (!saved) {
        return defaultKey;
      }
      const parsed = JSON.parse(saved) as unknown;
      if (typeof parsed === "string") {
        return allowedKeys.includes(parsed as T) ? (parsed as T) : defaultKey;
      }
      return defaultKey;
    } catch {
      return defaultKey;
    }
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    localStorage.setItem(storageKey, JSON.stringify(state));
  }, [state, storageKey]);

  return { state, setState };
};
